import TokenRequestModel from '../../generated/types/model/resource/TokenRequestModel';

export default class TokenRequestViewModel extends TokenRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
